module.exports = __webpack_public_path__ + "img/ico-hidden.4354f5c9.svg";